<template>
    <div>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item>
                    <i class='el-icon-lx-cascades'></i> 线下付款管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container'>
            <div class='handle-box'>

                <el-button type='primary' icon='el-icon-search' @click='handleSearch'>查询</el-button>
                <!--                <el-button type='primary' icon='el-icon-add' @click='handleAdd'>添加</el-button>-->
            </div>
            <el-table
                :data='tableData'
                border
                class='table'
                ref='multipleTable'
                header-cell-class-name='table-header'
            >

                <el-table-column label='序号' align='center' :index='indexMethod' type='index' width='40'>
                </el-table-column>
                <el-table-column type='selection' width='55' align='center' v-if='false'></el-table-column>
                <el-table-column prop='name' label='对公账号名称' align='center'></el-table-column>

                <el-table-column prop='area' label='银行名称' align='center'>
                    <template slot-scope='scope'>{{ scope.row.bankName }}</template>

                </el-table-column>
                <el-table-column prop='area' label='账号' align='center'>
                    <template slot-scope='scope'>{{ scope.row.account }}</template>

                </el-table-column>
                <el-table-column prop='area' label='备注' align='center'>
                    <template slot-scope='scope'>{{ scope.row.remark }}</template>

                </el-table-column>
<!--                <el-table-column prop='area' label='出生年月' align='center'>-->
<!--                    <template slot-scope='scope'>{{ scope.row.birthday }}</template>-->

<!--                </el-table-column>-->


                <el-table-column label='操作' width='180' align='center'>
                    <template slot-scope='scope'>
                        <el-button
                            type='text'
                            icon='el-icon-edit'
                            @click='handleEdit(scope.$index, scope.row)'
                        >编辑
                        </el-button>
<!--                        <el-button-->
<!--                            type='text'-->
<!--                            icon='el-icon-delete'-->
<!--                            class='red'-->
<!--                            @click='handleDelete(scope.$index, scope.row)'-->
<!--                        >删除-->
<!--                        </el-button>-->
                        <!--                        <el-button-->
                        <!--                            type='text'-->
                        <!--                            class='blue'-->
                        <!--                            @click='handleForbidden(scope.$index, scope.row)'-->
                        <!--                        >{{ scope.row.status === 0 ? '禁用' : '解除禁用' }}-->
                        <!--                        </el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination'>
                <el-pagination
                    background
                    layout='total, prev, pager, next'
                    :current-page='query.pageIndex'
                    :page-size='query.pageSize'
                    :total='pageTotal'
                    @current-change='handlePageChange'
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog title='编辑' :visible.sync='editVisible' width='40%'>


            <el-form ref='form' :model='form' label-width='120px'>

                <el-form-item label='对公账号名称'>
                    <el-input v-model='form.name' maxlength='11'></el-input>
                </el-form-item>
                <el-form-item label='银行名称'>
                    <el-input v-model='form.bankName' maxlength='11'></el-input>
                </el-form-item>
                <el-form-item label='账号'>
                    <el-input v-model='form.account' maxlength='11'></el-input>
                </el-form-item>

                <el-form-item label='备注'>
                    <el-input v-model='form.remark' maxlength='11'></el-input>
                </el-form-item>


            </el-form>

            <span slot='footer' class='dialog-footer'>
                <el-button @click='editVisible = false'>取 消</el-button>
                <el-button type='primary' @click='saveEdit'>更 新</el-button>
            </span>
        </el-dialog>

        <!-- 添加用户 -->
        <el-dialog title='添加人才' :visible.sync='addVisible' width='40%'>


            <el-form ref='form' :model='form' label-width='120px'>

                <el-form-item label='服务商名称'>
                    <el-input v-model='createForm.name' maxlength='11'></el-input>
                </el-form-item>
                <el-form-item label='省市'>
                    <el-cascader
                        v-model='value'
                        :props='defaultParams'
                        :options='options'
                        @change='handleChange'></el-cascader>
                </el-form-item>
                <el-form-item label='联系人'>
                    <el-input v-model='createForm.concatName' maxlength='11'></el-input>
                </el-form-item>
                <el-form-item label='联系电话'>
                    <el-input v-model='createForm.concatPhone' maxlength='11'></el-input>
                </el-form-item>
                <el-form-item label='合同复印件'>
                    <el-upload
                        class='upload-demo'
                        :on-preview='handlePreview'
                        :on-remove='handleRemove'
                        :before-upload='beforeAvatarUpload'
                        :file-list='[createForm.covenantUrl]'
                        limit='1'
                        action='https://jsonplaceholder.typicode.com/posts/'
                        :http-request='uploadFileCovenant'
                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>
                    </el-upload>
                </el-form-item>
                <el-form-item label='法人证件'>
                    <el-upload
                        class='upload-demo'
                        :on-preview='handlePreview'
                        :on-remove='handleRemove'
                        :before-upload='beforeAvatarUpload'
                        :file-list='[createForm.legalPersonUrl]'
                        limit='1'
                        action='https://jsonplaceholder.typicode.com/posts/'
                        :http-request='uploadFileLegalPerson'
                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>
                    </el-upload>

                </el-form-item>
                <el-form-item label='组织机构代码证'>
                    <el-upload
                        class='upload-demo'
                        :on-preview='handlePreview'
                        :on-remove='handleRemove'
                        :before-upload='beforeAvatarUpload'
                        :file-list='[createForm.orzUrl]'
                        limit='1'
                        action='https://jsonplaceholder.typicode.com/posts/'
                        :http-request='uploadFileOrzUrl'
                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>
                    </el-upload>

                </el-form-item>
                <el-form-item label='是否有客服'>
                    <el-radio v-model='radio' label='1'>是</el-radio>
                    <el-radio v-model='radio' label='0'>否</el-radio>
                </el-form-item>

            </el-form>
            <span slot='footer' class='dialog-footer'>
                <el-button @click='addVisible = false'>取 消</el-button>
                <el-button type='primary' @click='addUserHttp'>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { formatDate, formatDates } from '@/utils/formatDate';

export default {
    name: 'basetable',
    data() {
        return {
            radio: '1',
            fileList: [],
            workType: '',
            value: [],
            options: [],
            query: {
                name: '',
                educationRank: '',
                pageIndex: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            addVisible: false,
            cityOptions:[],
            cityIds:[],
            workTypeIds:[],


            createForm: {
                'concatPhone': '',
                'concatName': '',
                'name': '',
                'covenantUrl': '',
                'legalPersonUrl': '',
                'orzUrl': '',
                'isCustomerService': '1',
                'provinceId': '',
                'cityId': ''

            }
            ,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1

        };
    },
    created() {
        this.getData();
        this.getWorkTypeList();
        this.getCityBack()
        // this.getCity();
    },


    methods: {
        indexMethod(index) {
            return index + 1;
        },
        handlePreview(file) {

        },
        uploadFileCovenant(file) {
            let that = this;
            this.http.postFile('/local_file', file.file).then(res => {
                // 上传成功后的处理
                if (res.data.code == 0) {
                    console.log(res.data);
                    that.form.photoUrls=[{url:that.http.getDownLoadUrl() + res.data.data[0]}]

                    that.form.photoUrl =that.http.getDownLoadUrl() +  res.data.data[0];
                }
            }, err => {
                // 出现错误时的处理
            });
        },
        uploadFileLegalPerson(file) {
            let that = this;
            this.http.postFile('/uploadFile', file.file).then(res => {
                // 上传成功后的处理
                console.log(res.data);
                if (res.data.code == 0) {
                    that.createForm.legalPersonUrl = res.data.data;
                    that.form.legalPersonUrl = res.data.data;
                }
            }, err => {
                // 出现错误时的处理
                console.log(res);
            });
        },
        uploadFileOrzUrl(file) {
            let that = this;
            this.http.postFile('/uploadFile', file.file).then(res => {
                // 上传成功后的处理
                console.log(res.data);
                if (res.data.code == 0) {
                    that.createForm.orzUrl = res.data.data;
                    that.form.orzUrl = res.data.data;

                }
            }, err => {
                // 出现错误时的处理
                console.log(res);
            });
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type.includes('image');
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('文件只能是图片格式');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        }
        ,
        // 获取 easy-mock 的模拟数据
        getData() {
            let that = this;



            this.http.get('/pay/getOfflinePayment', this.query).then(res => {
                    if (res.code == 0) {
                        that.tableData = res.data;
                        this.$message.success('获取数据成功');

                    }
                },
                err => {

                });
        },
        getWorkTypeList() {
            let that = this;
            this.http.get('/workType/getWorkTypeList', {}).then(res => {
                    if (res.code == 0) {
                        that.options = res.data;

                    }
                },
                err => {

                });
        },

        getCityBack() {
            let that = this;
            this.http.get('/user/getBackCity', {}).then(res => {
                    if (res.code == 0) {
                        that.cityOptions = res.data;

                    }
                },
                err => {

                });
        },
        getCity() {
            let that = this;


            this.http.getToken('serviceProvider/getCity', this.query).then(res => {
                    if (res.code == 0) {
                        that.options = res.data;

                    }
                },
                err => {

                });
        },
        // 触发搜索按钮
        handleSearch() {
            this.query.pageIndex = 1;
            this.getData();

        },
        delUserHttp(id) {
            let that = this;
            this.http.post('user/delUserById', { 'id': id, 'status': 1 }).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        that.$message.success('删除成功');
                    }
                },
                err => {

                });
        }
        ,

        editUserHttp(params) {
            let that = this;

            this.http.post('pay/editOfflinePaymentById', params).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        this.editVisible = false;
                        that.$message.success('编辑成功');
                    }
                },
                err => {

                });
        }
        ,
        handleAdd() {
            this.addVisible = true;
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            let that = this;
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.delUserHttp(row.id);

                })
                .catch(() => {
                });
        },

        addUser() {
            this.createForm = {};
            this.value = [];
            this.addVisible = true;


        },

        addUserHttp() {
            if (this.value.length != 2) {
                this.$message.error('省市未选择');
                return;
            }
            this.createForm.provinceId = this.value[0];
            this.createForm.cityId = this.value[1];
            this.createForm.isCustomerService = this.radio;

            let that = this;
            this.http.postToken('serviceProvider/add', this.createForm).then(res => {
                if (res.code === 0) {
                    that.getData();
                    that.addVisible = false;
                }

            });
        }
        ,
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].name + ' ';
            }
            this.$message.error(`删除了${str}`);
            this.multipleSelection = [];
        },
        //禁用
        handleForbidden(index, row) {
            // 二次确认删除
            console.log(index);
            console.log(row.uid);
            let that = this;
            let params = {};
            let msg = '';
            if (row.status == 0) {
                msg = '确定要' + '禁用' + '吗？';
                params = { 'id': row.id, 'status': 2 };
            } else {
                msg = '确定要' + '解除禁用' + '吗？';
                params = { 'id': row.id, 'status': 0 };
            }

            this.$confirm(msg, '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.http.postToken('serviceProvider/updateStatus', params).then(res => {
                        if (res.code == 0) {
                            that.getData();
                            this.$message.success('操作成功');
                        }
                    });

                })
                .catch(() => {
                });
        },
        // 编辑操作
        handleEdit(index, row) {
            this.form = JSON.parse(JSON.stringify(row));
            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {

            this.editUserHttp(this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.avatar-uploader .el-upload {
    border-radius: 6px;
    width: 80px;
    height: 80px;
    text-align: center;

}

.avatar-uploader {
    border-color: #409EFF;
    text-align: center;
    margin-bottom: 40px;
    text-align: center;

}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    text-align: center;
}

.avatar {
    width: 80px;
    height: 80px;
    display: block;
    margin: auto auto;
    text-align: center;
}

.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
